<template>
  <div>
    <Main
      :loading="loading"
      :tableData="tableData"
      :showDefaultImage="showDefaultImage"
      @openDetailDialog="openDetailDialog"
      ref="tableMain"
    >
    </Main>
    <GoodsSpecDetailDialog
      :visible.sync="goodsSpecDetailDialogOptions.visible"
      :title="
        $l('INDEX.dialog_title_production_order_spec_detail') ||
          '订单产品信息规格详情'
      "
      :orderGoodsSpecCode="goodsSpecDetailDialogOptions.code"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import GoodsSpecDetailDialog from '../detail/dialog.vue'
export default {
  components: { Main, GoodsSpecDetailDialog },
  props: {
    orderGoodsCode: { type: String, default: '' },
    showDefaultImage: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      goodsSpecDetailDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderGoodsCode) return
      this.loading = true
      this.$api
        .pendingOrderGoodsSpecListApi({ orderGoodsCode: this.orderGoodsCode })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
    openDetailDialog({ orderGoodsSpecCode }) {
      this.goodsSpecDetailDialogOptions = {
        visible: true,
        code: orderGoodsSpecCode,
      }
    },
  },
}
</script>
